import wrapWithProvider from "./wrap-with-providers"
import get from "lodash/get"

export const wrapRootElement = wrapWithProvider

export const shouldUpdateScroll = ({ pathname, prevRouterProps }) => {
  const prevPathname = get(prevRouterProps, "location.pathname", null)
  return pathname !== prevPathname
}
